import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import ReorderResizeTable from 'components/ReorderResizeTable';

import {
  COLUMNS,
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  ViewAndDownloadFileStatsTableData,
  BODY_CONTENT_GENERATE,
} from './data';

import './ViewAndDownloadFileStatsTable.styles.scss';

type ViewAndDownloadFileStatsTableProps = {
  className?: string;
  isLoading?: boolean;
  isDragDisabled?: boolean;
  totalPages?: number;
  data: ViewAndDownloadFileStatsTableData[];
  numberOfPlaceholderRows: number;
  pageParam?: string;
  sort: string;
  updateSort: (value: string) => void;
};

const ViewAndDownloadFileStatsTable: FC<ViewAndDownloadFileStatsTableProps> = (
  props,
) => {
  const {
    className,
    isLoading,
    data,
    numberOfPlaceholderRows,
    pageParam,
    sort,
    isDragDisabled = true,
    totalPages = 1,
    updateSort,
  } = props;

  const classes = classNames('view-and-download-file-stats-table', className);

  const tableContentTransformations = useMemo(
    () =>
      COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (data: ViewAndDownloadFileStatsTableData) =>
            BODY_CONTENT_GENERATE[col]({
              data,
            }),
        }),
        {},
      ),
    [],
  );

  return (
    <ReorderResizeTable
      className={classes}
      isDragDisabled={isDragDisabled}
      totalPages={totalPages}
      data={data}
      columns={COLUMNS}
      headingTranslations={HEADING_TRANSLATIONS}
      sortingValues={SORTING_VALUES}
      isDataLoading={isLoading}
      tableContentTransformations={tableContentTransformations}
      customSizes={CUSTOM_COL_SIZES}
      numberOfPlaceholderRows={numberOfPlaceholderRows}
      pageParam={pageParam}
      sort={sort}
      updateSort={updateSort}
    />
  );
};

export default ViewAndDownloadFileStatsTable;
